import FeatureGates from '@atlaskit/feature-gate-js-client';
import { AnalyticsClient } from '../../../../utilities/analytics/analytics-web-client';

type ApplicationData = {
  coreApplication: string;
  experience?: string;
};

export const checkDirectSignupExperiment = ({
  applicationData,
  analyticsClient,
}: {
  applicationData?: ApplicationData;
  analyticsClient?: AnalyticsClient;
}) => {
  try {
    const cohortValue = FeatureGates.getExperimentValue(
      'ghost_advanced_cobranding_direct_signup',
      'cohort',
      'not-enrolled'
    ) as 'experiment' | 'control' | 'not-enrolled';

    analyticsClient?.trackingEvent({
      page: 'trello-direct-signup',
      action: 'exposed',
      subject: 'ghost_advanced_cobranding_direct_signup',
      attributes: {
        flagKey: 'ghost_advanced_cobranding_direct_signup',
        group: cohortValue,
        application: applicationData?.coreApplication,
        experience: applicationData?.experience,
      },
    });

    return cohortValue === 'experiment';
  } catch (error) {
    analyticsClient?.operationalEvent({
      page: 'trello-direct-signup',
      action: 'failed',
      subject: 'ghost_advanced_cobranding_direct_signup',
      attributes: {
        flagKey: 'ghost_advanced_cobranding_direct_signup',
        application: applicationData?.coreApplication,
        experience: applicationData?.experience,
        errorName: error?.name,
        errorStack: error?.stack,
        errorMessage: error?.message,
        errorCode: error?.code,
      },
    });

    console.error('Error checking ghost_advanced_cobranding_direct_signup', error);
    return false;
  }
};
